<template>
  <div :class="classModifiers">
    <div :class="symbolClassModifiers"></div>
    <div class="document-to-review__info">
      <div class="document-to-review__label-wrapper">
        <div class="document-to-review__label" v-if="showLabel">
          <template v-if="opened">Reviewed</template>
          <template v-else>Unopened</template>
        </div>
        <div class="document-to-review__label-suffix">
          <template v-if="hasSlotSuffix">
            <slot name="suffix"></slot>
          </template>
          <template v-else> Doc #{{ num }} </template>
        </div>
      </div>
      <div class="document-to-review__title" v-if="title">
        {{ title }}
      </div>
      <div class="document-to-review__description" v-if="description">
        {{ description }}
      </div>
    </div>
    <a :href="link" v-outer-link class="document-to-review__button" @click="onOpen">
      <div class="document-to-review__button-tick" v-if="markOpened && opened"></div>
      <template v-else>Open</template>
    </a>
  </div>
</template>

<script src="./document-to-review.js"></script>
<style src="./document-to-review.scss" lang="scss"></style>
